import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import AnalyticsCard from './AnalyticsCard';

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const relevance =
    payload[0] && payload[1]
      ? ((payload[1].value / payload[0].value) * 100).toFixed(1)
      : null;
  return (
    <div className="bg-background-secondary border border-border-primary rounded-lg shadow-lg p-3 text-xs">
      <p className="font-semibold text-text-primary mb-1.5">{label}</p>
      {payload.map((p) => (
        <p key={p.name} className="flex items-center gap-2" style={{ color: p.color }}>
          <span className="w-2 h-2 rounded-full inline-block" style={{ background: p.color }} />
          {p.name}: <span className="font-bold ml-auto pl-2">{p.value?.toLocaleString()}</span>
        </p>
      ))}
      {relevance && (
        <p className="text-text-secondary mt-1 border-t border-border-primary pt-1">
          Relevance: <span className="font-bold text-text-primary">{relevance}%</span>
        </p>
      )}
    </div>
  );
}

export default function ImageAnalytics({ data }) {
  return (
    <AnalyticsCard title="Image Upload Analytics — Monthly (Uploaded vs Relevant)">
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={data} margin={{ top: 4, right: 8, left: -10, bottom: 0 }}>
          <defs>
            <linearGradient id="gradUploaded" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%"  stopColor="#0066cc" stopOpacity={0.2} />
              <stop offset="95%" stopColor="#0066cc" stopOpacity={0.02} />
            </linearGradient>
            <linearGradient id="gradRelevant" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%"  stopColor="#10b981" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#10b981" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="month" tick={{ fontSize: 10, fill: '#7e848c' }} interval={3} />
          <YAxis tick={{ fontSize: 10, fill: '#7e848c' }} />
          <Tooltip content={<ChartTooltip />} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Area type="monotone" dataKey="uploaded" name="Uploaded Images" stroke="#0066cc" strokeWidth={2} fill="url(#gradUploaded)" />
          <Area type="monotone" dataKey="relevant"  name="Relevant Images"  stroke="#10b981" strokeWidth={2} fill="url(#gradRelevant)" />
        </AreaChart>
      </ResponsiveContainer>
    </AnalyticsCard>
  );
}
